import { createReducer, on } from '@ngrx/store';
import { Order } from '@app/services/order/order.model';
import { DeletedOrdersActions } from '../actions';

export const featureKey = 'orders';

export interface State {
  orders: Order[];
  countOrders: number;
  loading: boolean;
  loaded: boolean;
}

export const initialState: State = {
  orders: null,
  countOrders: null,
  loading: false,
  loaded: false,
};

export const reducer = createReducer(
  initialState,
  on(DeletedOrdersActions.loadDeletedOrders, (state: State) => ({
    ...state,
    loading: true,
  })),
  on(DeletedOrdersActions.loadDeletedOrdersSuccess, (state: State, { orders, count }) => ({
    ...state,
    orders,
    countOrders: count,
    loading: false,
    loaded: true,
  })),
  on(DeletedOrdersActions.loadDeletedOrdersFailure, (state: State) => ({
    ...state,
    orders: null,
    countOrders: null,
    loading: false,
  })),

  on(DeletedOrdersActions.setDeletedOrdersLoading, (state: State, { loading }) => ({
    ...state,
    loading,
  })),

  on(DeletedOrdersActions.restoreOrders, (state: State) => ({
    ...state,
    loading: true,
  })),
  on(DeletedOrdersActions.restoreOrdersSuccess, (state: State) => ({
    ...state,
    loading: false,
  })),
  on(DeletedOrdersActions.restoreOrdersFailure, (state: State) => ({
    ...state,
    loading: false,
  })),
);

export const getOrders = (state: State): Order[] => state.orders;
export const getCountOrders = (state: State): number => state.countOrders;
export const getLoading = (state: State): boolean => state.loading;
